document.addEventListener("DOMContentLoaded", () => {
  var alcatrazCartOutdate = document.querySelector(".alcatraz-cart-outdate");

  if (alcatrazCartOutdate && alcatrazCartOutdate.textContent > 0) {
    var time = alcatrazCartOutdate.textContent;
    var totalSeconds = time;
    var chosenTicket = document.createElement("a");

    chosenTicket.href = "/cart";
    chosenTicket.classList.add("chosen-ticket");
    chosenTicket.innerHTML =
      "<div class='description'>Chosen ticket is available</div><div class='label-time'><div>for: </div><div class='time-left'></div></div>";
    document.body.insertBefore(chosenTicket, document.body.firstChild);

    function Aredirect() {
      window.location.replace("/san-francisco/alcatraz-ticket-lost");
      document.querySelector("form").addEventListener("submit", function (e) {
        e.preventDefault();
      });
    }

    setInterval(function () {
      totalSeconds = totalSeconds - 1;

      if (totalSeconds >= 0) {
        chosenTicket.querySelector(".time-left").textContent =
          get_elapsed_time_string(totalSeconds);
      }
    }, 1000);

    setTimeout(Aredirect, time * 1000);

    function get_elapsed_time_string(total_seconds) {
      function pretty_time_string(num) {
        return (num < 10 ? "0" : "") + num;
      }

      var minutes = Math.floor(total_seconds / 60);
      total_seconds = total_seconds % 60;

      var seconds = Math.floor(total_seconds);

      minutes = pretty_time_string(minutes);
      seconds = pretty_time_string(seconds);

      return minutes + ":" + seconds;
    }
  }

  if (
    document.querySelector(".path-cart") ||
    document.querySelector(".path-checkout")
  ) {
    const productQty = document
    .querySelector(".cart.cart-form tr.Alcatraz.ticket .product-quantity")
    
    if(productQty) {
      productQty.remove();
    }
      
  }
});